import { InjectionToken, Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { tap } from 'rxjs/operators';

export interface TechLibPortalConfig {
  appName: string;
  sessionToken: string;
  apiKey: string;
  formatsTech: string;
  clientCode: string;
  domainData?: any;
  smsCode?: any;
  baseApi: string;
  base: string;
  angularAppsBase: string;
  baseOnboarding: string;
  tabTitle: string;
  currencySymbolBase: string;
  currencyBase: string;
  reCaptchaKey: string;
  domain: string;
  language: string;
  minLengthPass: number;
  passRequirement: string;
  production: string;
  useApiRest: string;
  SMSVerification: string;
  IsResident: string;
  IsForeigner: string;
  defaultCodeCountry: string;
  defaultCodeCountryPhone: string;
  backgroundEffect: string;
  toNewQuestionnaire: string;
  RoboOperationsValidation: string;
  ContactEmailOperations: string;
  custodian: string;
  accessToken?: string;
}

export const TECH_LIB_PORTAL_CONFIG = new InjectionToken<TechLibPortalConfig>(
  'TechLibPortal Config'
);

@Injectable()
export class TechLibPortalInterceptor implements HttpInterceptor {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig
  ) {}

  private httpOptionsHeader(rq): HttpHeaders {
    let headers: HttpHeaders = rq.headers; //Retrieve headers previously set in the request
    if (!headers.get('Content-Type')) {
      headers = headers.set(
        'Content-Type',
        'application/json; charset=UTF-8'
      );
    }
    if (this.config.smsCode) {
      headers = headers.set('Tower30-SMSCode', this.config.smsCode);
    }
    if (this.config.accessToken) {
      headers = headers.set(
        'Authorization',
        `Bearer ${this.config.accessToken}`
      );
    }
    if(this.config.language) {
      headers = headers.set('Tower30-Language', this.config.language);
    }
    if(this.config.domain) {
      headers = headers.set('Tower30-Domain', this.config.domain);
    }

    if(localStorage.getItem('isAdvisor') === 'true'){
      headers = headers.set('Tower30-isAdvisor', 'true');
    }

    return headers;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let auth = req.clone({
      headers: this.httpOptionsHeader(req),
    });

    return next.handle(auth).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          /*if (event.url.includes('api/common/get_userbusinessarea')) {
            this.config.domainData = event.body;
          }*/
          if (event.headers.get('Tower30-Sessiontoken')) {
            this.config.accessToken = event.headers
              .get('Tower30-Sessiontoken')
              .replace('Bearer ', '');
          }
          if (event.body && event.body.ClientCode) {
            this.config.clientCode = event.body.ClientCode;
          }
          if (event.body && event.body.Language) {
            this.config.language = event.body.Language;
          }
          if (event.body && event.body.id_token) {
            this.config.accessToken = event.body.id_token;
          }
          if (event.body && event.body.access_token) {
            this.config.accessToken = event.body.access_token;
          }
          if (event.body && event.body.TokenJWT) {
            this.config.accessToken = event.body.TokenJWT;
          }
          if (event.body) {
            try {
              let jsonTkn = JSON.parse(event.body);
              if (jsonTkn && jsonTkn.TokenJWT) {
                this.config.accessToken = jsonTkn.TokenJWT;
              }
            } catch (ex) {}
          }
        }
        return event;
      })
    );
  }
}
